import * as React from 'react';
import { CalendarEvent } from '../BigCalendar';
import { Grid, Typography, CircularProgress, Checkbox, FormControlLabel } from '@material-ui/core';
import TextField from '../../TextField/TextField';
import { ActivitySchedule, ActivityState } from '../../../model/activities';
import { contact } from '../../../model/contact';
import NumericField from '../../NumericField/NumericField';
import ConfirmButton from '../../Button/ConfirmButton';
import UndoButton from '../../Button/UndoButton';
import DeleteButton from '../../Button/DeleteButton';
import DatePicker from '../../DatePicker/DatePicker';
import HourPicker from '../../HourPicker/HourPicker';
import { Select, SelectItem } from '../../select/Select';
import { tag } from '../../../model/tag';
import Button from '../../Button/Button';
import { ReservationsDialog } from './ReservationsDialog';
import { trainer } from '../../../model/trainer';
import NewItemButton from '../../Button/NewItemButton';
import { TrainerDisplay } from '../../../scenes/activities/components/TrainerDisplay';

interface IProps {
    event: CalendarEvent;
    classes: any;
    onSave: (a: ActivitySchedule, updateSimilar: boolean) => any;
    onAddReservation?: (contact: contact, schedule: ActivitySchedule) => any;
    onRemoveReservation?: (scheduleId: string, id: string) => any;
    onDelete?: (id: string) => any;
    onUndo?: () => any;
    loading: boolean;
    maxDate: Date;
    minDate: Date;
    disabled?: boolean;
    fullEdit?: boolean;
    allTags?: tag[];
    trainers: trainer[];
}
export const CalendarDetail = (props: IProps) => {
    const [original, setOriginal] = React.useState<ActivitySchedule>();
    const [current, setCurrent] = React.useState<ActivitySchedule>();
    const [errorDate, setErrorDate] = React.useState(false);
    const [errorTime, setErrorTime] = React.useState(false);
    const [tag, setTag] = React.useState<tag>()
    const [dialogReservations, setDialogReservations] = React.useState(false);
    const [updateSimilar, setUpdateSimilar] = React.useState(false);
    const [selectedTrainers, setSelectedTrainers] = React.useState<trainer[]>([]);
    const [selectedTrainer, setSelectedTrainer] = React.useState<SelectItem>();

    React.useEffect(() => {
        if (props.trainers && props.trainers.length) {
            const t = props.trainers.filter(a => (props.event.resource.trainerIds || []).indexOf(a._id) > -1);
            setSelectedTrainers(t);
        }
    }, [props.event, props.trainers])
    const s = props.event?.resource || {} as ActivitySchedule;
    React.useEffect(() => {
        setOriginal(props.event?.resource);
        setCurrent(props.event?.resource);
    }, [props.event])

    const saveEnabled = () => {

        const isNew = !Boolean(original._id)

        const differs = JSON.stringify(original) !== JSON.stringify(current);

        if (!differs && !isNew) return false;
        var ret = true;
        if (current.isReservable && !current.capacity)
            ret = false;
        ret = ret && Boolean(current.date && current.duration);
        ret = ret && !errorDate && !errorTime;
        return ret;
    }
    const undoClick = () => {
        if (props.onUndo)
            props.onUndo();
        setCurrent(original)
    }
    const setHour = (h: number, m: number) => {
        if (!isNaN(h) && !isNaN(m)) {
            setCurrent({ ...current, date: new Date(current.date.getFullYear(), current.date.getMonth(), current.date.getDate(), h, m, 0) });
            setErrorTime(false)
        }
        else setErrorTime(true)
    }
    const setDate = (d: Date) => {
        if (d && (d instanceof Date) && !isNaN(d.getDate())) {
            setCurrent({ ...current, date: new Date(d.getFullYear(), d.getMonth(), d.getDate(), current.date.getHours(), current.date.getMinutes(), 0) })
            setErrorDate(false)
        }
        else setErrorDate(true)
    }
    const setDescription = (val: string) => {
        setCurrent({ ...current, description: val });
    }
    const setDisplayName = (val: string) => {
        setCurrent({ ...current, displayName: val });
    }
    const setReservable = (val: boolean) => {
        setCurrent({ ...current, isReservable: val });
    }
    const availableTrainers = () => {
        const ret = [];
        (props.trainers || []).forEach(a => {
            if (selectedTrainers && selectedTrainers.findIndex(t => t._id === a._id) === -1)
                ret.push({ name: a.name, value: a._id });
        });
        return ret;
    }
    const addTrainer = () => {
        const toAdd = selectedTrainer;
        if (selectedTrainer && selectedTrainers.findIndex(a => a._id === toAdd.value) === -1) {
            const newTrainers = [...selectedTrainers, props.trainers.find(a => a._id === toAdd.value)]
            setSelectedTrainers(newTrainers);
            setCurrent({ ...current, trainerIds: newTrainers.map(a => a._id) });
        }
    }
    const removeTrainer = (id: string) => {
        var toRemove = selectedTrainers.findIndex(a => a._id === id);
        if (toRemove > -1) {
            selectedTrainers.splice(toRemove, 1);
            const newList = [...selectedTrainers];
            setSelectedTrainers(newList);
            setCurrent({ ...current, trainerIds: newList.map(a => a._id) });
        }
    }

    const { loading, disabled, fullEdit, allTags } = props;
    const schedule = props.event.resource as ActivitySchedule;
    return <Grid container style={{ justifyContent: 'center' }}>
        {loading && <Grid item xs={12} justify={"center"} style={{ display: 'flex' }}>
            <CircularProgress size={80} />
        </Grid>}
        {(current && !loading) && <>
            {props.onAddReservation && props.onRemoveReservation && schedule?.isReservable && schedule?.state === ActivityState.approved && <Grid item sm={12} style={{ display: 'flex', justifyContent: 'space-between', paddingRight: 15, alignItems: 'center' }}>
                <Typography>{schedule.reservations?.length || 0} prenotazioni</Typography>
                <Button className={props.classes.btnReservations} onClick={() => setDialogReservations(true)}>Dettagli</Button>
            </Grid>}
            <Grid item sm={12} style={{ padding: 5 }}>
                <TextField disabled={!fullEdit} label='Nome visualizzato' value={current.displayName || ''} onChange={setDisplayName} />
            </Grid>
            <Grid item sm={12} style={{ padding: 5 }}>
                <TextField disabled={!fullEdit} label='Descrizione' value={current.description || ''} onChange={setDescription} />
            </Grid>
            <Grid item sm={6} style={{ padding: 5 }}>
                <DatePicker disabled={disabled && !fullEdit} key={`event_${current._id}`} label='Data' value={current.date} onChange={setDate} />
            </Grid>
            <Grid item sm={6} style={{ padding: 5 }}>
                <HourPicker disabled={disabled && !fullEdit} label='Orario di inizio' value={{ hours: current.date?.getHours(), minutes: current.date?.getMinutes() }}
                    onChange={setHour} />
            </Grid>
            <Grid item sm={6} style={{ padding: 5 }}>
                {/* && !fullEdit */}
                <NumericField disabled={disabled} label='Durata' value={current.duration} onChange={val => setCurrent({ ...current, duration: val })} />
            </Grid>
            <Grid item sm={6} style={{ padding: 5 }}>
                {/* && !fullEdit */}
                <NumericField disabled={disabled} label='Capienza' value={current.capacity} onChange={val => setCurrent({ ...current, capacity: val })} />
            </Grid>
            {!fullEdit && <Grid item sm={12} style={{ padding: 5 }}>
                <TextField disabled label='Categoria' value={s.tag?.description || 'non definito'} />
            </Grid>
            }
            {fullEdit && <Grid item sm={12} style={{ padding: 5 }}>
                <Select fullWidth
                    selected={tag ? { name: tag.description, value: tag.code } : undefined}
                    items={allTags.map(t => { return { name: t.description, value: t.code } })}
                    onChange={(item) => setTag(allTags.find(t => t.code === item.value))}
                    label='Categoria' />
            </Grid>}
            {fullEdit && <Grid item sm={12} style={{ padding: 5 }}>
                <FormControlLabel className={props.classes.newActivityCheckBoxLabel}
                    control={<Checkbox
                        checked={current.isReservable}
                        onChange={(e, val) => setReservable(val)}
                    />}
                    label={'Prenotabile'}
                />

            </Grid>}
            <Grid container className={props.classes.trainersContainer}>
                {schedule.state === ActivityState.approved && <>
                    <Grid item sm={8}>
                        <Select fullWidth label={'Istruttori'} selected={selectedTrainer} items={availableTrainers()} onChange={(i) => { setSelectedTrainer(i) }} />
                    </Grid>
                    <Grid item xs={4} className={props.classes.addTrainerButtonContainer}>
                        <NewItemButton text='Aggiungi' onClick={addTrainer} disabled={!selectedTrainer} />
                    </Grid>
                </>}
                <Grid item sm={12} style={{ marginBottom: 15 }}>
                    {selectedTrainers.map(t => {
                        return <TrainerDisplay disabled={schedule.state !== ActivityState.approved} trainer={t} removeTrainer={removeTrainer} />
                    })}
                </Grid>
            </Grid>
            <Grid container sm={12} className={props.classes.buttonsContainer}>
                <FormControlLabel className={props.classes.newActivityCheckBoxLabel}
                    control={<Checkbox
                        checked={updateSimilar}
                        onChange={(e, val) => setUpdateSimilar(val)}
                    />}
                    label={'Aggiornamento Record Simili'}
                />
                <label style={{ fontSize: '13px', marginTop: '-5px', marginBottom: '5px' }}>Dopo l'aggiornamento dei record simili, ricaricare la pagina</label>
            </Grid>
            <Grid container sm={12} className={props.classes.buttonsContainer}>
                <ConfirmButton text='Salva' onClick={(e) => props.onSave(current, updateSimilar)} disabled={(disabled && !fullEdit) || !saveEnabled()} />
                <UndoButton text='Annulla' onClick={(e) => undoClick()} disabled={(disabled && !fullEdit) || !saveEnabled()} />
                {props.onDelete && <DeleteButton disabled={disabled && !fullEdit} text='Elimina' onClick={(e) => props.onDelete(original._id)} />}
            </Grid>
            <ReservationsDialog open={dialogReservations}
                onCancel={() => setDialogReservations(false)}
                onAddReservation={props.onAddReservation}
                onRemoveReservation={props.onRemoveReservation}
                classes={props.classes}
                schedule={schedule}
                loading={false}
            />
        </>}
    </Grid>
}
